var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-about",on:{"click":function($event){return _vm.$router.push('/about')}}},[_c('h4',[_vm._v(_vm._s(_vm.FullYear)+"年品牌值得信赖")]),_c('p',[_vm._v("打造中国一流的智力文化企业")])])}
var staticRenderFns = []

export { render, staticRenderFns }